export const isSet = value => value !== undefined && value !== null;
export const isUnset = value => value === undefined || value === null;
export const defaultsTo = (value, defaultValue) =>
  isSet(value) ? value : defaultValue;
export const propDefaultsTo = (obj, key, defaultValue) =>
  obj && key in obj ? obj[key] : defaultValue;
export const oneSet = (...args) => args.find(isSet);
export const allSet = (...args) => {
  let v = true;
  args.every(p => v = p);
  return v;
};
export const isOneSet = (...args) => isSet(oneSet(...args));
export const areAllSet = (...args) => isSet(allSet(...args));
